import React from 'react'

import { BasePageProps } from '@/Pages/types'

import UnauthenticatedLayout from '@/Components/Layout/UnauthenticatedLayout'
import Page from '@/Components/Pages/Accounts/ActivationPage'

export type AccountActivationPageProps = BasePageProps & {
  user: {
    first_name: string
    last_name: string
    email: string
    id: number | string
    invitation_token: string
  }
}

const AccountActivationPage: React.FC<AccountActivationPageProps> = ({
  env,
  user
}) => {
  return (
    <UnauthenticatedLayout env={env}>
      <Page {...user} />
    </UnauthenticatedLayout>
  )
}

export default AccountActivationPage
